import React from "react";
import Typography from "@material-ui/core/Typography";
import { RouteComponentProps } from "react-router";
import { ApplicationState } from "../../store";
import * as APIStore from "../../store/APIStore";
import { useState, useEffect } from "react";
import { connect, useSelector } from "react-redux";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@material-ui/core";

import RequestAccessToken from '../../util/authService';
import { Link, useHistory } from "react-router-dom";
import CircularProgress from '@material-ui/core/CircularProgress';
import { formatDate } from "../common/DateHelper";

export interface DocumentsByPatientsProps {
    downloadablePatientDocuments: APIStore.DownloadablePatientDocument[],
    apiHost: string
}

const DocumentsIndex = (props: DocumentsByPatientsProps) => {
    let { downloadablePatientDocuments, apiHost } = props;
    let [downloadingState, setDownloadState] = useState('');

    let [tokenState, setTokenState] = useState<APIStore.TokenType>();

    const history = useHistory();

    let tokenStatePr = RequestAccessToken()
        .then((token) => {
            if (token && !tokenState) {
                setTokenState(token);
            }
        });

    const downloadDocument = (documentId: string, documentName: string, extension: string, path: string, accessToken: string, document: any) => {

        setDownloadState(documentName);

        let request = {
            DocumentId: documentId,
            Name: documentName,
            Extension: extension,
            Path: path
        }
        debugger;

        const options = {
            method: "POST",
            headers: {
                Accept: "application/json",
                'Content-Type': 'application/json;',
                Authorization: `Bearer ${accessToken}`,
            },
            body: JSON.stringify(request)
        };

        fetch(`https://${apiHost}/api/AzureStorage/PatientDocuments/`, options)
            .then((res) => { return res.blob(); })
            .then((data) => {
                let a = document.createElement("a")
                a.href = window.URL.createObjectURL(data);
                a.download = documentName;
                a.click();
                setDownloadState('');;
            }).catch((err) => {
                setDownloadState('');
            })
    }

    const downloadDoc = (e: any, documentId: string, documentFileName: string, extension: string, path: string) => {
        e.preventDefault();

        if (tokenState) {
            downloadDocument(documentId, documentFileName, extension, path, tokenState.accessToken, document)
        }
    };

    if (!downloadablePatientDocuments?.length) {
        return (<>
        </>);
    }

    return (
        <React.Fragment>
            <Typography variant="body1" component="div" gutterBottom>
                <strong>eNotes:</strong>
            </Typography>

            <TableContainer >
                <Table aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Name</TableCell>
                            <TableCell align="right">Created By</TableCell>
                            <TableCell align="right">Date</TableCell>
                            <TableCell align="right"></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>


                        {downloadablePatientDocuments.map((val: APIStore.DownloadablePatientDocument) => (

                            <TableRow>
                                <TableCell component="th" scope="row">


                                    <Link onClick={(e) => { downloadDoc(e, val.id, val.name, val.extension, val.path) }} to={val.path}>
                                        <Typography component="p" color="primary" gutterBottom>
                                            {val.name}
                                        </Typography>


                                    </Link>



                                </TableCell>
                                <TableCell align="right">
                                    {val.createdBy}
                                </TableCell>
                                <TableCell align="right">

                                    {formatDate(val.createdDate, true)}

                                </TableCell>
                                <TableCell align="right">

                                    {val.name == downloadingState ? <CircularProgress /> : <React.Fragment />}

                                </TableCell>
                            </TableRow>
                        ))}
                        <TableRow>
                            <TableCell component="th" scope="row">
                                {

                                }
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        </React.Fragment>
    );
};

export default connect(
    (state: ApplicationState) => state.vitalsContext,
    APIStore.actionCreators
)(DocumentsIndex as any);
